module.exports = __webpack_public_path__ + "img/apartment.4873ec26.svg";